<template>
    <div>
        <AppNavbar />
        <PagesHero :breadcrumbData="{
            title: $t('privacy.title'),
            subtitle: {
                first_text: $t('privacy.label'),
                first_href: '/',
                second_text: $t('privacy.title')
            }
        }" />
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h3 class="title">{{ $t('privacy.head1') }}</h3>
                    <h4 class="subtitle">{{ $t("privacy.p1_1") }}</h4>

                    <h3 class="title">{{ $t('privacy.head2') }}</h3>
                    <h4 class="subtitle">{{ $t("privacy.p2_1") }}</h4>
                    <h4 class="subtitle">{{ $t("privacy.p2_2") }}</h4>
                    <h4 class="subtitle">{{ $t("privacy.p2_3") }}</h4>

                    <h3 class="title">{{ $t('privacy.head3') }}</h3>
                    <h4 class="subtitle">{{ $t("privacy.p3_1") }}</h4>
                    <h4 class="subtitle">{{ $t("privacy.p3_2") }}</h4>

                    <h3 class="title">{{ $t('privacy.head4') }}</h3>
                    <h4 class="subtitle">{{ $t("privacy.p4_1") }}</h4>
                    <h4 class="subtitle">{{ $t("privacy.p4_2") }}</h4>
                    <h4 class="subtitle">{{ $t("privacy.p4_3") }}</h4>

                    <h3 class="title">{{ $t('privacy.head5') }}</h3>
                    <h4 class="subtitle">{{ $t("privacy.p5_1") }}</h4>

                    <h3 class="title">{{ $t('privacy.head6') }}</h3>
                    <h4 class="subtitle">{{ $t("privacy.p6_1") }}</h4>

                    <h3 class="title">{{ $t('privacy.head7') }}</h3>
                    <h4 class="subtitle">{{ $t("privacy.p7_1") }}</h4>

                    <h3 class="title">{{ $t('privacy.head8') }}</h3>
                    <h4 class="subtitle">{{ $t("privacy.p8_1") }}</h4>
                    <h4 class="subtitle">{{ $t("privacy.p8_2") }}</h4>

                    <h3 class="title">{{ $t('privacy.head9') }}</h3>
                    <h4 class="subtitle">{{ $t("privacy.p9_1") }}</h4>

                    <h3 class="title">{{ $t('privacy.head10') }}</h3>
                    <h4 class="subtitle">{{ $t("privacy.p10_1", { email: 'info@forqan.com' }) }}</h4>
                    <h4 class="subtitle">{{ $t("privacy.p10_2") }}</h4>

                    <h3 class="title">{{ $t('privacy.head11') }}</h3>
                    <h4 class="subtitle">{{ $t("privacy.p11_1", { email: 'info@forqan.com' }) }}</h4>

                </div>
            </div>
        </div>


        <AppFooter />

    </div>
</template>

<script>
import AppFooter from '@/components/AppFooter.vue';
import AppNavbar from '@/components/AppNavbar.vue';
import PagesHero from '@/components/PagesHero.vue';


export default {
    components: {
        AppNavbar, PagesHero, AppFooter
    }
}

</script>

<style scoped>
.row {
    margin-top: 40px;
}

.title {
    font-size: 24px;
    font-weight: 500;
    color: #BF9F35;
    margin-top: 20px;
    margin-bottom: 20px;
}

.subtitle {
    font-size: 20px;
    font-weight: 400;
    color: #393735;
    margin-bottom: 10px;
}

.container {
    padding-bottom: 80px;
}
</style>